<template>
<v-dialog persistent
width="300"
align="center"
:value="isLoading"
content-class="global-loading-dialog">
    <v-sheet
    class="pa-5"
    width="max"
    align="center"
    rounded>
        <div class="loader"
        ></div>
        <div class="mt-7">Loading</div>
        </v-sheet>
</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            isLoading: state => state.general.isLoading
        })
    }
}
</script>

<style>
.loader {
  border: 10px solid #f3f3f3; /* Light grey */
  border-top: 10px solid #4caf50; /* Blue */
  border-radius: 50%;
  margin: 5px;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ต้องแสดงเหนือ custom modal overlay ทุกตัวในแอป (z-index: 9999)
   หมายเหตุ: content-class ของ Vuetify v-dialog ติดที่ .v-dialog (ลูก, position:static)
   ไม่ใช่ .v-dialog__content (แม่, position:fixed) ที่เป็นตัวกำหนด stacking จริง
   จึงต้อง target .v-dialog__content ผ่าน :has() โดยตรง */
.v-dialog__content:has(.global-loading-dialog) {
  z-index: 20000 !important;
}
</style>
